import { StatusHubpspot } from "@/@types/integrations";
import state from "./state";

const getters = {
  /**
   * Retorna los datos del usuario logueado.
   */
  getDataUser: (state) => state.data_user,
  getStateUser: (state) => state.stateUser,
  getAllowSendTemplate: (state) => state.allowSendTemplate,

  getMinutesExpire: (state) => state.minutes_expire,
  getDataUserState: (state) => state.dataUserState,

  getDataPlanDetails: (state) => state.dataPlanDetails,
  getDataPlanConfiguration: (state) => state.dataPlanDetails?.configuration,
  /**
   * Valida si un evento de socket pertenece al usuario actual.
   * Acepta `iduser` o `user_id` en el payload del evento.
   * @returns {function(Object): boolean}
   */
  isSocketEventForCurrentUser: (state) => (data) => {
    const userId = state.data_user?.id;
    if (!userId) return false;

    const eventUserId = data?.iduser ?? data?.user_id;
    if (eventUserId == null) {
      console.warn("[Socket Validation] El evento no tiene un iduser", data);
      return false;
    }

    return Number(eventUserId) === Number(userId);
  },
  hasHubspotActive: (state) => {
    const hub = state.data_user?.customer?.hubspot_data;
    return [StatusHubpspot.Integrated, StatusHubpspot.ToUpdate].includes(hub?.state);
  },
  // retorna si tiene acceso a una determinada funcionalidad de hubspot
  hasHubspotByCode: (state) => (code) => {
    const hub = state.data_user?.customer?.hubspot_data;

    console.log("hubspot_data", hub);
    if (!hub || hub?.state !== 1) return false;

    console.log("hubspot_functionalities", hub?.functionalities);
    console.log("hubspot_code", code)
    return hub?.functionalities?.some(
      f => f.code === code && f.active === true
    ) ?? false;
  },
  // retorna si tiene acceso a una determinada funcionalidad de hubspot
  getHubspotByCode: (state) => (code) => {
    const hub = state.data_user?.customer?.hubspot_data;

    if (!hub || hub?.state !== 1) return null;

    return hub?.functionalities?.find(
      f => f.code === code && f.active === true
    );
  },
  hasHubspotFunctionalityActive: (state) => {
    const hub = state.data_user?.customer?.hubspot_data;
    return hub?.functionalities?.some(f => f.active === true) ?? false;
  }
};
export default getters;
